// Mirror of the Go-side util.SanitizePHI / util.SanitizeBodyPHI helpers.
// Keeps patient identifying data out of PostHog $exception events captured
// from the frontend. Patterns must stay in sync with util/phcapture.go.

const emailRE = /[A-Za-z0-9._%+\-]+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,}/g;
const phoneRE = /(?:\+\d{1,3}[-.\s]?)?\(?\d{3}\)?[-.\s]\d{3}[-.\s]\d{4}\b/g;
const ssnRE = /\b\d{3}[-\s]?\d{2}[-\s]?\d{4}\b/g;
const mbiRE = /\b[1-9][A-Za-z][A-Za-z0-9]\d[A-Za-z][A-Za-z0-9]\d[A-Za-z]{2}\d{2}\b/g;
const dobRE = /\b\d{1,2}[/\-]\d{1,2}[/\-]\d{2,4}\b/g;
const nameHintRE = /(first[_ ]?name|last[_ ]?name|full[_ ]?name|patient[_ ]?name|\bname)([^A-Za-z0-9\n]{1,5})([A-Za-z][A-Za-z\-]{0,39})/gi;

const sensitiveKeyRE = /email|phone|ssn|mbi|dob|birth|first[_ ]?name|last[_ ]?name|address|medicare|password|token|secret/i;

const MAX_BYTES = 4096;

export function sanitizeString(s) {
  if (typeof s !== 'string') return s;
  return s
    .replace(emailRE, '[email]')
    .replace(ssnRE, '[ssn]')
    .replace(mbiRE, '[mbi]')
    .replace(dobRE, '[date]')
    .replace(phoneRE, '[phone]')
    .replace(nameHintRE, '$1$2[name]');
}

function redactDeep(value) {
  if (value === null || value === undefined) return value;
  if (typeof value === 'string') return sanitizeString(value);
  if (Array.isArray(value)) return value.map(redactDeep);
  if (typeof value === 'object') {
    const out = {};
    for (const [k, v] of Object.entries(value)) {
      if (sensitiveKeyRE.test(k)) {
        out[k] = `[redacted:${k}]`;
      } else {
        out[k] = redactDeep(v);
      }
    }
    return out;
  }
  return value;
}

// sanitizeBody accepts a string or object and returns a sanitized JSON string
// suitable for attaching to a PostHog event property. Output is truncated.
export function sanitizeBody(input) {
  if (input === null || input === undefined || input === '') return '';
  try {
    let parsed = input;
    if (typeof input === 'string') {
      try {
        parsed = JSON.parse(input);
      } catch {
        return truncate(sanitizeString(input));
      }
    }
    const redacted = redactDeep(parsed);
    return truncate(JSON.stringify(redacted));
  } catch {
    return '';
  }
}

function truncate(s) {
  if (typeof s !== 'string') return s;
  if (s.length <= MAX_BYTES) return s;
  return s.slice(0, MAX_BYTES) + '…[truncated]';
}
